import {
  FC,
  useState,
  useEffect,
  useCallback,
  Dispatch,
  SetStateAction
} from "react";
import { useWatch } from "antd/es/form/Form";

import {
  FormInstance,
} from "antd";
import PanelLayout, { IPanelLayoutProps } from "components/ui/Panel/PanelLayout";

import { ImportMasterFormType } from "pages/ImportMasterPage";
import useFormInstance from "antd/es/form/hooks/useFormInstance";
import FileUploadBlock from "./FileUploadBlock";
import SettingsBlock from "./SettingsBlock";
import LoadingRulesModal from "components/modals/LoadingRulesModal/LoadingRulesModal";
import InfoNotification from "components/ImportMaster/utils/InfoNotification/InfoNotification";

export const SETTINGS_TYPE = {
  isPeriodic: "is_periodic",
  updateRest: "rests",
  updatePrice: "prices",
  updateProperty: "attributes",
  clearProducts: "clear_existing",
  firstLineSkip: "first_line_skip",
  logIn: "log_in",
};

interface IImportYMLProps {
  isPeriodicTaskEditMode: boolean;
  uploadMode: "file" | "url";
  setUploadMode: Dispatch<SetStateAction<"file" | "url">>;
  initialSettings?: any;
}

const ImportYML: FC<IImportYMLProps> = ({
  isPeriodicTaskEditMode,
  uploadMode,
  setUploadMode
}) => {
  const form: FormInstance<ImportMasterFormType> = useFormInstance();
  const values = useWatch<ImportMasterFormType>([], form);

  const [isOpenModal, setOpenModal] = useState<boolean>(false);

  const handleOpenModal = (): void => setOpenModal(true);

  const handleCancelModal = (): void => setOpenModal(false);

  const PANEL_LAYOUT_PROPS: IPanelLayoutProps = {
    title: { content: "Загрузка через YML", size: "large" },
    description: {
      content: <>
        YML (Yandex Market Language) - это стандарт, разработанный Yandex
        для приема и публикации информации в базе данных Yandex.Market.
        <a
          className="blue-color pl-2"
          href="https://yandex.ru/support/marketplace/ru/assortment/auto/yml"
          target="blank"
        >
          Подробнее
        </a>
      </>,
      notification: <InfoNotification handleOpenModal={handleOpenModal} />,
    },
    className: "flex flex-col md:flex-row gap-5"
  };

  const [uploadSettings, setUploadSettings] = useState<any[]>([]);

  useEffect(() => {
    !!uploadSettings && form.setFieldValue("settings", uploadSettings.map((value) => value));
  }, [form, uploadSettings]);

  useEffect(() => {
    form.resetFields(["settings"]);
  }, [uploadMode]);

  return (
    <>
      <PanelLayout {...PANEL_LAYOUT_PROPS}>
        <FileUploadBlock
          needAuth={values?.settings?.includes(SETTINGS_TYPE.logIn)}
          isPeriodic={values?.settings?.includes(SETTINGS_TYPE.isPeriodic)}
          setUploadMode={setUploadMode}
          uploadMode={uploadMode}
          isPeriodicTaskEditMode={isPeriodicTaskEditMode}
        />
        <SettingsBlock
          uploadMode={uploadMode}
          isPeriodicTaskEditMode={isPeriodicTaskEditMode}
        />
      </PanelLayout>
      <LoadingRulesModal
        isOpen={isOpenModal}
        onCancelHandler={handleCancelModal}
        variant="yml"
      />
    </>
  );
};

export default ImportYML;
